const spacing = {
  full: '100%',
  px: '1px',
  0: '0rem',
  2: '0.125rem', // 2px
  4: '0.25rem', // 4px
  6: '0.4375rem', // 6px
  8: '0.5rem', // 8px
  10: '0.625rem',
  12: '0.75rem', // 12px
  16: '1rem',
  20: '1.25rem',
  24: '1.5rem',
  28: '1.75rem',
  32: '2rem',
  36: '2.25rem',
  40: '2.5rem',
  44: '2.75rem',
  48: '3rem',
  52: '3.25rem',
  56: '3.5rem',
  64: '4rem',
  80: '5rem',
  96: '6rem',
  112: '7rem',
  128: '8rem',
  114: '9rem',
  160: '10rem',
  176: '11rem',
  192: '12rem',
  224: '14rem',
  240: '15rem',
  256: '16rem',
  288: '18rem',
  320: '20rem',
  384: '24rem',
};

export default spacing;
